export default __webpack_public_path__ + "static/media/investment_card_1@2x.522f50dd.png";